import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { useDeletePreFolderAsync } from '@/features/easy/preFolderQualification/apis';
import { ToasterState } from '@/features/shared/types';

export const useCancelPreFolderQualification = () => {
  const { t } = useTranslation('borderPassEasyWithRORO_prefolderQualification');
  const { folderId } = useParams();
  const navigate = useNavigate();
  const [isCancelPreFolderAlertDialogOpen, setIsCancelPreFolderAlertDialogOpen] = useState(false);
  const { mutate: cancelPreFolder, isLoading: isCancelPreFolderPending } = useDeletePreFolderAsync();
  const [cancelPreFolderState, setCancelPreFolderState] = useState<ToasterState>({
    isToasterOpen: false,
  });

  const handleCancelPreFolder = useCallback(() => {
    setIsCancelPreFolderAlertDialogOpen(true);
  }, []);

  const handleAgreeCancelPreFolder = useCallback(() => {
    cancelPreFolder(
      {
        folderId,
      },
      {
        onSuccess: () => {
          setCancelPreFolderState({
            isToasterOpen: true,
            severity: 'success',
            content: t('borderPassEasyWithRORO.preFolderQualification.cancelPreFolder.success.content'),
          });

          setTimeout(() => {
            navigate('/folders');
          }, 2000);
        },
        onError: () => {
          setCancelPreFolderState({
            isToasterOpen: true,
            severity: 'error',
            content: t('borderPassEasyWithRORO.preFolderQualification.cancelPreFolder.error.content'),
          });
        },
      },
    );

    setIsCancelPreFolderAlertDialogOpen(false);
  }, [folderId, cancelPreFolder, navigate, t]);

  const handleOnDisagreeCancelPreFolder = useCallback(() => {
    setIsCancelPreFolderAlertDialogOpen(false);
  }, []);

  const handleCloseCanclPreFolderToaster = useCallback(() => {
    setCancelPreFolderState({ isToasterOpen: false });
  }, []);

  return {
    isCancelPreFolderAlertDialogOpen,
    isCancelPreFolderPending,
    cancelPreFolderState,
    handleCancelPreFolder,
    handleAgreeCancelPreFolder,
    handleOnDisagreeCancelPreFolder,
    handleCloseCanclPreFolderToaster,
  };
};
